import * as React from "react";
import {
  Grid,
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  Select,
  InputLabel,
  MenuItem,
  Typography,
} from "@mui/material";
import PairingAlertDialog from "./PairingAlertDialog";
import { EventContext } from "../../../contexts/EventContext";
import request from "../../../utilities/requests";

const EventDialog = ({ open, close, event }) => {
  const { userData } = React.useContext(EventContext);
  const [pairingAlertOpen, setPairingAlertOpen] = React.useState(false);
  const [pairingEvent, setPairingEvent] = React.useState(null);
  const [canDelete, setCanDelete] = React.useState(false);
  const [showDelete, setShowDelete] = React.useState(false);
  const [eventName, setEventName] = React.useState("");

  React.useEffect(() => {
    if (event?.eventType === "Pairing") {
      getPairingEvent();
    }
  }, [event]);

  React.useEffect(() => {
    if (userData?.role === "superadmin") {
      setCanDelete(true);
    }
  }, [userData]);

  const handleClose = () => {
    setShowDelete(false);
    setEventName("");
    close();
  };

  const getPairingEvent = async () => {
    try {
      const result = await request(`pairingevent?eventId=${event._id}`);
      if (result.success) {
        setPairingEvent(result?.pairingEvents);
      }
    } catch (e) {
      var error = `Error: ${e.message}`;
      console.error(error);
    }
  };

  const handlePairingEventTypeChange = async (e) => {
    const body = {
      pairingEventId: pairingEvent._id,
      update: {
        pairingEventType: e.target.value,
      },
    };
    try {
      const result = await request("pairingevent/update", "post", body);
      if (result.success) {
        await getPairingEvent();
      }
    } catch (e) {
      var error = `Error xxx. Error: ${e.message}`;
      console.error(error);
      return { success: false, error: error };
    }
  };

  const handleTypeChange = async (e) => {
    if (e.target.value === "Pairing" && event.eventType !== "Pairing") {
      setPairingAlertOpen(true);
    } else if (event.eventType === "Pairing" && e.target.value !== "Pairing") {
      alert(
        "This event has already marked as a Pairing Event. You cannot change that! Call David"
      );
    } else {
      const updateData = {
        eventId: event._id,
        update: { eventType: e.target.value },
      };
      const result = await editEvent(updateData);
      if (!result.success) {
        alert(result.error);
      }
    }
  };

  const handleClosePairingAlert = () => {
    setPairingAlertOpen(false);
  };

  const handleConfirmPairing = async () => {
    const body = { eventId: event._id, update: { eventType: "Pairing" } };
    const pairingResult = await editEvent(body);
    if (!pairingResult.success) {
      console.error(pairingResult.error);
      alert(pairingResult.error);
    }
    console.log("event type updated successfully to Pairing");

    const createBody = { eventId: event._id };
    const createEvent = await request(
      "pairingevent/create",
      "post",
      createBody
    );
    if (!createEvent.success) {
      console.error(createEvent.error);
      alert(createEvent.error);
    }
    console.log("Pairing event created successfully");
    setPairingAlertOpen(false);
    close();
  };

  const editEvent = async (data) => {
    const result = await request("events/update", "post", data);
    return result;
  };

  const handleDeleteEvent = async () => {
    const body = { eventId: event._id };
    const result = await request("events/delete", "post", body);
    if (result.success) {
      alert("Event deleted successfully");
    }
    handleClose();
  };

  const renderSubEventType = () => {
    if (event?.eventType === "Pairing") {
      return (
        <Grid item>
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">
              Pairing Event Type
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={
                pairingEvent?.pairingEventType
                  ? pairingEvent.pairingEventType
                  : "select"
              }
              label="Pairing Event Type"
              onChange={handlePairingEventTypeChange}
            >
              <MenuItem value={"select"}>Select</MenuItem>
              <MenuItem value={"hetero"}>hetero</MenuItem>
              <MenuItem value={"lgbtq"}>LGBTQ</MenuItem>
              <MenuItem value={"friend"}>Friend</MenuItem>
              <MenuItem value={"casualEncountersHetero"}>
                Chance Encounters - Hetero
              </MenuItem>
              <MenuItem value={"casualEncountersGay"}>
                Chance Encounters - Gay
              </MenuItem>
              <MenuItem value={"casualEncountersFriend"}>
                Chance Encounters - Friend
              </MenuItem>
            </Select>
          </FormControl>
        </Grid>
      );
    }

    return <></>;
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth>
      <DialogTitle style={{display:'flex', flexDirection:'row', justifyContent: 'space-between'}}>
        <Typography variant="h6">Event Details</Typography>
        <Typography variant="caption" style={{color: 'grey'}}>{`${event?._id}`}</Typography>
        </DialogTitle>
      <DialogContent>
        <DialogContentText>Edit Event Details</DialogContentText>
        <Grid container flexDirection="column" spacing={3}>
          <Grid item>
            <TextField
              autoFocus
              margin="dense"
              label="Name"
              type="text"
              fullWidth
              variant="standard"
              value={event ? event.name : ""}
              disabled={true}
            />
          </Grid>
          <Grid item>
            <TextField
              autoFocus
              margin="dense"
              label="Description"
              type="text"
              fullWidth
              variant="standard"
              value={event ? event.description : ""}
              disabled={true}
              multiline
            />
          </Grid>
          <Grid item>
            <TextField
              autoFocus
              margin="dense"
              label="Date"
              type="text"
              fullWidth
              variant="standard"
              value={event ? event.date : ""}
              disabled={true}
            />
          </Grid>
          <Grid item>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Event Type</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={event ? event.eventType : "Select"}
                label="Event Type"
                onChange={handleTypeChange}
              >
                <MenuItem value={"Select"}>Select</MenuItem>
                <MenuItem value={"Pairing"}>Pairing</MenuItem>
                <MenuItem value={"SportsAndWellness"}>
                  Sports & Wellness
                </MenuItem>
                <MenuItem value={"ArtsAndEntertainment"}>
                  Arts & Entertainments
                </MenuItem>
                <MenuItem value={"Exchange"}>Exchange </MenuItem>
                <MenuItem value={"Other"}>Other</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          {renderSubEventType()}
          {showDelete ? (
            <></>
          ) : (
            <Grid item>
              {canDelete ? (
                <Button variant="outlined" onClick={() => setShowDelete(true)}>
                  Delete Event
                </Button>
              ) : (
                <></>
              )}
            </Grid>
          )}
          {showDelete ? (
            <Grid item>
              <Typography style={{ color: "red" }}>
                Type the full name of the event to confirm deletion
              </Typography>
              <TextField
                fullWidth
                variant="standard"
                value={eventName}
                onChange={(e) => setEventName(e.target.value)}
                onPaste={(e) => e.preventDefault()}
              />
              {event?.name === eventName ? (
                <Button style={{ color: "red" }} onClick={handleDeleteEvent}>
                  Delete
                </Button>
              ) : (
                <></>
              )}
            </Grid>
          ) : (
            <></>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Save</Button>
        <Button onClick={handleClose}>Cancel</Button>
      </DialogActions>
      <PairingAlertDialog
        open={pairingAlertOpen}
        close={handleClosePairingAlert}
        confirm={handleConfirmPairing}
      />
    </Dialog>
  );
};

export default EventDialog;
